import { Card } from "@/components/ui/Card"
import { formatMoney } from "@/lib/money"

interface Props {
  // `market` names the channel's market when the list spans several.
  channels: { name: string; market?: string; revenue: number }[]
  currency: string
  subtitle?: string
}

/** Revenue by channel this month, biggest first, bars relative to the biggest. */
export default function ChannelBars({ channels, currency, subtitle = "This month so far" }: Props) {
  const max = Math.max(...channels.map((c) => c.revenue))
  const total = channels.reduce((sum, c) => sum + c.revenue, 0)

  return (
    <Card className="px-5 py-4">
      <div className="text-sm font-semibold">Revenue by channel</div>
      <div className="mb-3 text-xs text-muted-foreground">{subtitle}</div>
      {channels.length === 0 && <div className="text-sm">No sales this month yet.</div>}
      <div className="flex flex-col gap-3">
        {channels.map((c) => (
          <div key={`${c.market ?? ""}/${c.name}`} className="flex flex-col gap-1">
            <div className="flex items-baseline justify-between text-sm">
              <span>
                {c.name}
                {c.market && <span className="ml-2 text-xs">{c.market}</span>}
              </span>
              <span className="tabular-nums">
                <span className="font-medium">{formatMoney(c.revenue, currency)}</span>
                <span className="ml-2 text-xs">{Math.round((c.revenue / total) * 100)}%</span>
              </span>
            </div>
            <div className="h-2 overflow-hidden rounded-full bg-muted">
              <div className="h-full rounded-full bg-primary/40" style={{ width: `${(c.revenue / max) * 100}%` }} />
            </div>
          </div>
        ))}
      </div>
    </Card>
  )
}
